export const BaseUrl = 'https://api.bawabatek.com/';//stage=>3008, dev=>3009
export const API_KEY = 'al-mahara-2023-development-api-key';
export const WORKING_KEY = 'A69E7CACFA5DB54F66E2B0BD1830E866' //'EE7011F11B93A71FA2A57861571A0385';
export const MURCHAND_ID = 'AVHX04LC90AL32XHLA' //'AVIK04JG35BN29KINB';
export const FB_SOCIAL_KEY =  `250424591281826`;
export const GOOGLE_SOCIAL_KEY =  '501986747114-kami4bma7krsti3vfaa2tqi63iu7pc61.apps.googleusercontent.com';
export const GOOGLE_PLACES_API_KEY = `AIzaSyD-N8juGZkx72ZlDVByhmb9Dz_ke62d-sQ`;
export const GOOGLE_PLACES_API_KEY_2 = `AIzaSyCnh7agGdJb0rp61DBu4FShy5mbK5_k_XI`//for get country name 
